export class PricePriceDimensionModel {
    public pricePriceDimensionId: string;
    public pricePriceDimensionTypeCode: string;
    public priceRuleAttributeTypeCode: string;
    public displaySequence: number;
}